/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MeRouteImport } from './routes/me'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MeIndexRouteImport } from './routes/me/index'
import { Route as MeInviteRouteImport } from './routes/me_.invite'
import { Route as MeProfileRouteImport } from './routes/me/profile'
import { Route as MeAccountRouteImport } from './routes/me/account'

const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MeIndexRoute = MeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MeRoute,
} as any)
const MeInviteRoute = MeInviteRouteImport.update({
  id: '/me_/invite',
  path: '/me/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const MeProfileRoute = MeProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => MeRoute,
} as any)
const MeAccountRoute = MeAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => MeRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/me': typeof MeRouteWithChildren
  '/me/account': typeof MeAccountRoute
  '/me/profile': typeof MeProfileRoute
  '/me/invite': typeof MeInviteRoute
  '/me/': typeof MeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/me/account': typeof MeAccountRoute
  '/me/profile': typeof MeProfileRoute
  '/me/invite': typeof MeInviteRoute
  '/me': typeof MeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/me': typeof MeRouteWithChildren
  '/me/account': typeof MeAccountRoute
  '/me/profile': typeof MeProfileRoute
  '/me_/invite': typeof MeInviteRoute
  '/me/': typeof MeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/me' | '/me/account' | '/me/profile' | '/me/invite' | '/me/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/me/account' | '/me/profile' | '/me/invite' | '/me'
  id:
    | '__root__'
    | '/'
    | '/me'
    | '/me/account'
    | '/me/profile'
    | '/me_/invite'
    | '/me/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MeRoute: typeof MeRouteWithChildren
  MeInviteRoute: typeof MeInviteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/': {
      id: '/me/'
      path: '/'
      fullPath: '/me/'
      preLoaderRoute: typeof MeIndexRouteImport
      parentRoute: typeof MeRoute
    }
    '/me_/invite': {
      id: '/me_/invite'
      path: '/me/invite'
      fullPath: '/me/invite'
      preLoaderRoute: typeof MeInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/profile': {
      id: '/me/profile'
      path: '/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof MeProfileRouteImport
      parentRoute: typeof MeRoute
    }
    '/me/account': {
      id: '/me/account'
      path: '/account'
      fullPath: '/me/account'
      preLoaderRoute: typeof MeAccountRouteImport
      parentRoute: typeof MeRoute
    }
  }
}

interface MeRouteChildren {
  MeAccountRoute: typeof MeAccountRoute
  MeProfileRoute: typeof MeProfileRoute
  MeIndexRoute: typeof MeIndexRoute
}

const MeRouteChildren: MeRouteChildren = {
  MeAccountRoute: MeAccountRoute,
  MeProfileRoute: MeProfileRoute,
  MeIndexRoute: MeIndexRoute,
}

const MeRouteWithChildren = MeRoute._addFileChildren(MeRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MeRoute: MeRouteWithChildren,
  MeInviteRoute: MeInviteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
